export const state = {
  country: [
    {
      name: {
        word: "Algerie",
        fr: "Algerie",
        en: "Algeria",
        ar: "الجزائر",
        tu: "Cezayir",
        lat: 36.74442239909969,
        long: 3.0726561299136623,
        flag: "inso-pics/dz.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "Adrar",
          ar_name: "أدرار",
          lat: 28.0174403,
          long: -0.2642497,
        },
        {
          id: "2",
          fr_name: "Chlef",
          ar_name: "الشلف",
          lat: 36.1579664,
          long: 1.3372823,
        },
        {
          id: "3",
          fr_name: "Laghouat",
          ar_name: "الأغواط",
          lat: 33.8078341,
          long: 2.8628294,
        },
        {
          id: "4",
          fr_name: "Oum El Bouaghi",
          ar_name: "أم البواقي",
          lat: 35.8688789,
          long: 7.110826599999999,
        },
        {
          id: "5",
          fr_name: "Batna",
          ar_name: "باتنة",
          lat: 35.5634192,
          long: 6.1889996,
        },
        {
          id: "6",
          fr_name: "Béjaïa",
          ar_name: "بجاية",
          lat: 36.7515258,
          long: 5.055683699999999,
        },
        {
          id: "7",
          fr_name: "Biskra",
          ar_name: "بسكرة",
          lat: 34.8449437,
          long: 5.7248567,
        },
        {
          id: "8",
          fr_name: "Bechar",
          ar_name: "بشار",
          lat: 31.6238098,
          long: -2.2162443,
        },
        {
          id: "9",
          fr_name: "Blida",
          ar_name: "البليدة",
          lat: 36.4735715,
          long: 2.8323153,
        },
        {
          id: "10",
          fr_name: "Bouira",
          ar_name: "البويرة",
          lat: 36.3691846,
          long: 3.900619399999999,
        },
        {
          id: "11",
          fr_name: "Tamanrasset",
          ar_name: "تمنراست",
          lat: 22.7902972,
          long: 5.5193268,
        },
        {
          id: "12",
          fr_name: "Tbessa",
          ar_name: "تبسة",
          lat: 35.4010797,
          long: 8.1172958,
        },
        {
          id: "13",
          fr_name: "Tlemcen",
          ar_name: "تلمسان",
          lat: 34.8828864,
          long: -1.3166815,
        },
        {
          id: "14",
          fr_name: "Tiaret",
          ar_name: "تيارت",
          lat: 35.3708689,
          long: 1.3217852,
        },
        {
          id: "15",
          fr_name: "Tizi Ouzou",
          ar_name: "تيزي وزو",
          lat: 36.713548,
          long: 4.0473075,
        },
        {
          id: "16",
          fr_name: "Alger",
          ar_name: "الجزائر",
          lat: 36.74442239909969,
          long: 3.0726561299136623,
        },
        {
          id: "17",
          fr_name: "Djelfa",
          ar_name: "الجلفة",
          lat: 34.6703956,
          long: 3.2503761,
        },
        {
          id: "18",
          fr_name: "Jijel",
          ar_name: "جيجل",
          lat: 36.8210144,
          long: 5.7634126,
        },
        {
          id: "19",
          fr_name: "Setif",
          ar_name: "سطيف",
          lat: 36.1897593,
          long: 5.4107984,
        },
        {
          id: "20",
          fr_name: "Saida",
          ar_name: "سعيدة",
          lat: 34.8415207,
          long: 0.1456055,
        },
        {
          id: "21",
          fr_name: "Skikda",
          ar_name: "سكيكدة",
          lat: 36.8662658,
          long: 6.9062556,
        },
        {
          id: "22",
          fr_name: "Sidi Bel Abbes",
          ar_name: "سيدي بلعباس",
          lat: 35.2105876,
          long: -0.629983,
        },
        {
          id: "23",
          fr_name: "Annaba",
          ar_name: "عنابة",
          lat: 36.9142081,
          long: 7.742667300000001,
        },
        {
          id: "24",
          fr_name: "Guelma",
          ar_name: "قالمة",
          lat: 36.4627444,
          long: 7.4330833,
        },
        {
          id: "25",
          fr_name: "Constantine",
          ar_name: "قسنطينة",
          lat: 36.3570052,
          long: 6.639028199999999,
        },
        {
          id: "26",
          fr_name: "Medea",
          ar_name: "المدية",
          lat: 36.2637078,
          long: 2.7587857,
        },
        {
          id: "27",
          fr_name: "Mostaganem",
          ar_name: "مستغانم",
          lat: 35.9311454,
          long: 0.09094139999999999,
        },
        {
          id: "28",
          fr_name: "M'Sila",
          ar_name: "المسيلة",
          lat: 35.7186646,
          long: 4.523342299999999,
        },
        {
          id: "29",
          fr_name: "Mascara",
          ar_name: "معسكر",
          lat: 35.4020988,
          long: 0.1400257,
        },
        {
          id: "30",
          fr_name: "Ouargla",
          ar_name: "ورقلة",
          lat: 31.9527411,
          long: 5.3335348,
        },
        {
          id: "31",
          fr_name: "Oran",
          ar_name: "وهران",
          lat: 35.6987388,
          long: -0.6349319,
        },
        {
          id: "32",
          fr_name: "El Bayadh",
          ar_name: "البيض",
          lat: 33.6854149,
          long: 1.0303543,
        },
        {
          id: "33",
          fr_name: "Illizi",
          ar_name: "إليزي",
          lat: 26.4775863,
          long: 8.4776326,
        },
        {
          id: "34",
          fr_name: "Bordj Bou Arreridj",
          ar_name: "برج بوعريريج",
          lat: 36.0739925,
          long: 4.7630271,
        },
        {
          id: "35",
          fr_name: "Boumerdes",
          ar_name: "بومرداس",
          lat: 36.7510697,
          long: 3.4788905,
        },
        {
          id: "36",
          fr_name: "El Tarf",
          ar_name: "الطارف",
          lat: 36.7576678,
          long: 8.3076343,
        },
        {
          id: "37",
          fr_name: "Tindouf",
          ar_name: "تندوف",
          lat: 27.6719159,
          long: -8.1398003,
        },
        {
          id: "38",
          fr_name: "Tissemsilt",
          ar_name: "تيسمسيلت",
          lat: 35.6053781,
          long: 1.813098,
        },
        {
          id: "39",
          fr_name: "El Oued",
          ar_name: "الوادي",
          lat: 33.367811,
          long: 6.8516511,
        },
        {
          id: "40",
          fr_name: "Khenchela",
          ar_name: "خنشلة",
          lat: 35.4269404,
          long: 7.1460155,
        },
        {
          id: "41",
          fr_name: "Souk Ahras",
          ar_name: "سوق أهراس",
          lat: 36.2801062,
          long: 7.938403299999999,
        },
        {
          id: "42",
          fr_name: "Tipaza",
          ar_name: "تيبازة",
          lat: 36.5906719,
          long: 2.4433723,
        },
        {
          id: "43",
          fr_name: "Mila",
          ar_name: "ميلة",
          lat: 36.36479569999999,
          long: 6.1526985,
        },
        {
          id: "44",
          fr_name: "Ain Defla",
          ar_name: "عين الدفلى",
          lat: 36.2509429,
          long: 1.9393815,
        },
        {
          id: "45",
          fr_name: "Naama",
          ar_name: "النعامة",
          lat: 33.2667317,
          long: -0.3128659,
        },
        {
          id: "46",
          fr_name: "Ain Temouchent",
          ar_name: "عين تموشنت",
          lat: 35.2992698,
          long: -1.1392792,
        },
        {
          id: "47",
          fr_name: "Ghardaefa",
          ar_name: "غرداية",
          lat: 32.4943741,
          long: 3.64446,
        },
        {
          id: "48",
          fr_name: "Relizane",
          ar_name: "غليزان",
          lat: 35.7450263,
          long: 0.5578837,
        },
        {
          id: "49",
          fr_name: "El M'ghair",
          ar_name: "المغير",
          lat: 33.950285,
          long: 5.9244238,
        },
        {
          id: "50",
          fr_name: "El Menia",
          ar_name: "المنيعة",
          lat: 30.5833161,
          long: 2.8836701,
        },
        {
          id: "51",
          fr_name: "Ouled Djellal",
          ar_name: "أولاد جلال",
          lat: 34.4294289,
          long: 5.0681159,
        },
        {
          id: "52",
          fr_name: "Bordj Baji Mokhtar",
          ar_name: "برج باجي مختار",
          lat: 21.32551,
          long: 0.9524803,
        },
        {
          id: "53",
          fr_name: "Béni Abbès",
          ar_name: "بني عباس",
          lat: 30.1312217,
          long: -2.1662258,
        },
        {
          id: "54",
          fr_name: "Timimoun",
          ar_name: "تيميمون",
          lat: 29.2616911,
          long: 0.2415964,
        },
        {
          id: "55",
          fr_name: "Touggourt",
          ar_name: "تقرت",
          lat: 33.1049642,
          long: 6.0662834,
        },
        {
          id: "56",
          fr_name: "Djanet",
          ar_name: "جانت",
          lat: 24.554151,
          long: 9.485429,
        },
        {
          id: "57",
          fr_name: "In Salah",
          ar_name: "عين صالح",
          lat: 27.2026311,
          long: 2.4878487,
        },
        {
          id: "58",
          fr_name: "In Guezzam",
          ar_name: "عين قزام",
          lat: 19.5632255,
          long: 5.7717952,
        },
      ],
    },
    {
      name: {
        word: "Tunisie",
        fr: "Tunisie",
        en: "Tunisia",
        ar: "تونس",
        tu: "Tunus",
        lat: 33.892166,
        long: 9.561555,
        flag: "inso-pics/tunisie.png",
      },
      wilaya: [
        {
          id: 1,
          fr_name: "Ariana",
          ar_name: "أريانة",
          lat: 36.8665367,
          long: 10.1647233,
        },
        {
          id: 2,
          fr_name: "Beja",
          ar_name: "باجة",
          lat: 36.7333193,
          long: 9.1843676,
        },
        {
          id: 3,
          fr_name: "Ben Arous",
          ar_name: "بن عروس",
          lat: 36.7435003,
          long: 10.2319757,
        },
        {
          id: 4,
          fr_name: "Bizerte",
          ar_name: "بنزرت",
          lat: 37.2767579,
          long: 9.8641609,
        },
        {
          id: 5,
          fr_name: "Gabes",
          ar_name: "قابس",
          lat: 33.888077,
          long: 10.0975221,
        },
        {
          id: 6,
          fr_name: "Gafsa",
          ar_name: "قفصة",
          lat: 34.4311398,
          long: 8.7756556,
        },
        {
          id: 7,
          fr_name: "Jendouba",
          ar_name: "جندوبة",
          lat: 36.5072263,
          long: 8.7756556,
        },
        {
          id: 8,
          fr_name: "Kairouan",
          ar_name: "القيروان",
          lat: 35.6711663,
          long: 10.1005469,
        },
        {
          id: 9,
          fr_name: "Kasserine",
          ar_name: "القصرين",
          lat: 35.17227159999999,
          long: 8.8307626,
        },
        {
          id: 10,
          fr_name: "Kebili",
          ar_name: "قبلي",
          lat: 33.7071551,
          long: 8.971462299999999,
        },
        {
          id: 11,
          fr_name: "Kef",
          ar_name: "الكاف",
          lat: 36.1679648,
          long: 8.7095789,
        },
        {
          id: 12,
          fr_name: "Mahdia",
          ar_name: "المهدية",
          lat: 35.5024461,
          long: 11.045721,
        },
        {
          id: 13,
          fr_name: "Manouba",
          ar_name: "منوبة",
          lat: 36.8093284,
          long: 10.0863269,
        },
        {
          id: 14,
          fr_name: "Medenine",
          ar_name: "مدنين",
          lat: 33.3399221,
          long: 10.4958678,
        },
        {
          id: 15,
          fr_name: "Monastir",
          ar_name: "	المنستير",
          lat: 35.7642515,
          long: 10.8112885,
        },
        {
          id: 16,
          fr_name: "Nabeul",
          ar_name: "نابل",
          lat: 36.4512893,
          long: 10.7356634,
        },
        {
          id: 17,
          fr_name: "Sfax",
          ar_name: "صفاقس",
          lat: 34.739822,
          long: 10.7600196,
        },
        {
          id: 18,
          fr_name: "Sidi Bou Zid",
          ar_name: "سيدي بوزيد",
          lat: 35.0354386,
          long: 9.4839392,
        },
        {
          id: 19,
          fr_name: "Siliana",
          ar_name: "سليانة",
          lat: 36.0887208,
          long: 9.3645335,
        },
        {
          id: 20,
          fr_name: "Sousse",
          ar_name: "سوسة",
          lat: 35.8245029,
          long: 10.634584,
        },
        {
          id: 21,
          fr_name: "Tataouine",
          ar_name: "تطاوين",
          lat: 32.9210902,
          long: 10.4508956,
        },
        {
          id: 22,
          fr_name: "Tozeur",
          ar_name: "توزر",
          lat: 33.918534,
          long: 8.1229329,
        },
        {
          id: 23,
          fr_name: "Tunis",
          ar_name: "تونس",
          lat: 36.8064948,
          long: 10.1815316,
        },
        {
          id: 24,
          fr_name: "Zaghouan",
          ar_name: "زغوان",
          lat: 36.4091188,
          long: 10.1423172,
        },
      ],
    },
    {
      name: {
        word:"Turc",
        fr: "Turc",
        en: "Turc",
        ar: "تركيا",
        tu: "Turc",
        lat: 40.945711799603615,
        long: 29.21994356201801,
        flag: "inso-pics/tu.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "Ankara",
          ar_name: "انقرة",
          lat: 39.9333635,
          long: 32.8597419,
        },
        {
          id: "2",
          fr_name: "Manisa",
          ar_name: "مانيسا",
          lat: 38.630554,
          long: 27.422222,
        },
        {
          id: "3",
          fr_name: "Diyarbakir",
          ar_name: "ديار بكر",
          lat: 37.91,
          long: 40.240002,
        },
        {
          id: "4",
          fr_name: "Izmit, Kocaeli",
          ar_name: "ايزميت",
          lat: 40.766666,
          long: 29.916668,
        },
        {
          id: "5",
          fr_name: "Gaziantep",
          ar_name: "غازي عنتاب",
          lat: 37.066666,
          long: 37.383331,
        },
        {
          id: "6",
          fr_name: "Sanliurfa",
          ar_name: "شانلي أورفا",
          lat: 37.158333,
          long: 38.791668,
        },
        {
          id: "7",
          fr_name: "Tekirdag",
          ar_name: "تاكيرداق",
          lat: 40.977779,
          long: 27.515278,
        },
        {
          id: "8",
          fr_name: "Adana",
          ar_name: "اظنة",
          lat: 37.0,
          long: 35.321335,
        },
        {
          id: "9",
          fr_name: "Antalya",
          ar_name: "انطاليا",
          lat: 36.884804,
          long: 30.704044,
        },
        {
          id: "10",
          fr_name: "Giresun",
          ar_name: "غيرسون",
          lat: 40.917534,
          long: 38.392654,
        },
        {
          id: "11",
          fr_name: "Yozgat",
          ar_name: "يوزغات",
          lat: 39.82206,
          long: 34.808132,
        },
        {
          id: "12",
          fr_name: "Bolu",
          ar_name: "بولو",
          lat: 40.731647,
          long: 31.589813,
        },
        {
          id: "13",
          fr_name: "Zonguldak",
          ar_name: "زونغولداق",
          lat: 37.91,
          long: 40.240002,
        },
        {
          id: "14",
          fr_name: "Van",
          ar_name: "فان",
          lat: 38.499817,
          long: 43.378143,
        },
        {
          id: "15",
          fr_name: "Denizli",
          ar_name: "دنيزلي",
          lat: 37.783333,
          long: 29.094715,
        },
        {
          id: "16",
          fr_name: "Istanbul",
          ar_name: "إسطنبول",
          lat: 41.015137,
          long: 28.97953,
        },
        {
          id: "30",
          fr_name: "Eskişehir",
          ar_name: "إسكي شهر",
          lat: 39.766193,
          long: 30.526714,
        },
        {
          id: "17",
          fr_name: "Artvin",
          ar_name: "أرتفين",
          lat: 41.183224,
          long: 41.830982,
        },
        {
          id: "18",
          fr_name: "Isparta",
          ar_name: "إسبرطة",
          lat: 37.768002,
          long: 30.561905,
        },
        {
          id: "19",
          fr_name: "Konya",
          ar_name: "قونية",
          lat: 37.874641,
          long: 32.493156,
        },
        {
          id: "20",
          fr_name: "Nevşehir",
          ar_name: "نوشهر",
          lat: 38.626995,
          long: 34.719975,
        },
        {
          id: "21",
          fr_name: "Mersin",
          ar_name: "مرسين",
          lat: 36.812103,
          long: 34.641479,
        },
        {
          id: "22",
          fr_name: "Rize",
          ar_name: "ريزا",
          lat: 41.025513,
          long: 40.517666,
        },
        {
          id: "23",
          fr_name: "Kahramanmaras",
          ar_name: "قهرمان مرعش",
          lat: 37.575275,
          long: 36.922821,
        },
        {
          id: "24",
          fr_name: "Bursa",
          ar_name: "بورصة",
          lat: 40.193298,
          long: 29.074202,
        },
        {
          id: "25",
          fr_name: "Kayseri",
          ar_name: "قيصري",
          lat: 38.734802,
          long: 35.467987,
        },
        {
          id: "26",
          fr_name: "Elazığ",
          ar_name: "إيلازيغ",
          lat: 38.680969,
          long: 39.226398,
        },
        {
          id: "27",
          fr_name: "Sakarya",
          ar_name: "صقاريا ",
          lat: 40.783333,
          long: 30.4,
        },
        {
          id: "28",
          fr_name: "Hatay",
          ar_name: "هاتاي",
          lat: 36.200001,
          long: 36.166668,
        },
        {
          id: "29",
          fr_name: "Edirne",
          ar_name: "أردنة",
          lat: 41.674965,
          long: 26.583481,
        },
        {
          id: "31",
          fr_name: "Malatya",
          ar_name: "ملطية",
          lat: 38.356869,
          long: 38.309669,
        },
        {
          id: "32",
          fr_name: "Sivas",
          ar_name: "سيفاس",
          lat: 39.750359,
          long: 39.750359,
        },
        {
          id: "33",
          fr_name: "Trabzon",
          ar_name: "طرابزون",
          lat: 41.002697,
          long: 39.716763,
        },
        {
          id: "34",
          fr_name: "Izmir",
          ar_name: "ازمير",
          lat: 38.423733,
          long: 27.142826,
        },
        {
          id: "35",
          fr_name: "Amasya",
          ar_name: "أماسيا",
          lat: 40.652382,
          long: 35.828819,
        },
        {
          id: "36",
          fr_name: "Afyonkarahisar",
          ar_name: "افیون قرهحصار",
          lat: 38.756886,
          long: 30.538704,
        },
      ],
    },
    {
      name: {
        word:"maroc",
        fr: "maroc",
        en: "maroc",
        ar: "المغرب",
        tu: "maroc",
        lat: 31.791702,
        long: -7.09262,
        flag: "inso-pics/morocco.png", 
      },
      wilaya: [
        {
          id: "1",
          fr_name: "casablanca",
          ar_name: "casablanca",
          lat: 33.573109,
          long: -7.589843,
        },
        {
          id: "2",
          fr_name: "rabat",
          ar_name: "الرباط",
          lat: 33.971588,
          long: -6.849813,
        },
        {
          id: "3",
          fr_name: "fes",
          ar_name: "فاس",
          lat: 34.059769,
          long: -4.96531,
        },
        {
          id: "4",
          fr_name: "merrakech",
          ar_name: "مراكش",
          lat: 31.625031,
          long: -7.99296,
        },
      ],
    },
    {
      name: {
        word:"saoudi-AR",
        fr: "saoudi-AR",
        en: "saoudi-AR",
        ar: "السعودية",
        tu: "saoudi-AR",
        lat: 24.6381917,
        long: 46.7101739,
        flag: "inso-pics/arabi.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "djeddah",
          ar_name: "جدة",
          lat: 21.5540349,
          long: 39.2087383,
        },
        {
          id: "2",
          fr_name: "riyad",
          ar_name: "الرياض",
          lat: 24.7047337,
          long: 46.6855856,
        },
        {
          id: "3",
          fr_name: "al madinah",
          ar_name: "المدينة",
          lat: 24.4575664,
          long: 39.6086339,
        },
        {
          id: "4",
          fr_name: "la mecque",
          ar_name: "مكة",
          lat: 21.3762957,
          long: 39.7946003,
        },
      ],
    },
    {
      name: {
        word:"libya",
        fr: "libya",
        en: "Libye",
        ar: "ليبيا",
        tu: "Libye",
        lat: 26.768524,
        long: 17.5066496,
        flag: "inso-pics/libya.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "tripoli",
          ar_name: "العناصر",
          lat: 32.8891753,
          long: 13.1932907,
        },
      ],
    },
    {
      name: {
        word:"canada",
        fr: "canada",
        en: "canada",
        ar: "كندا",
        tu: "canada",
        lat: 58.111966,
        long: -102.0323814,
        flag: "inso-pics/canada.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "ottawa",
          ar_name: "ottawa",
          lat: 45.4200146,
          long: -75.6895387,
        },
        {
          id: "2",
          fr_name: "montreal",
          ar_name: "montreal",
          lat: 45.5077734,
          long: -73.5544607,
        },
        {
          id: "3",
          fr_name: "quebec",
          ar_name: "quebec",
          lat: 53.2915896,
          long: -71.5164244,
        },
      ],
    },
    {
      name: {
        word:"Islande",
        fr: "islande",
        en: "islande",
        ar: "أيسلندا",
        tu: "islande",
        lat: 64.130796,
        long: -21.8744563,
        flag: "inso-pics/islande.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "reykjavik",
          ar_name: "reykjavik",
          lat: 64.1475973,
          long: -21.9386179,
        },
      ],
    },
    {
      name: {
        word: "Égypte",
        fr: "Égypte",
        en: "Egypt",
        ar: "مصر",
        tu: "Mısır",
        lat: 26.820553,
        long: 30.802498,
        flag: "inso-pics/egypt.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "Le Caire",
          en_name: "Cairo",
          ar_name: "القاهرة",
          tu_name: "Kahire",
          lat: 30.0444196,
          long: 31.2357116,
        },
        {
          id: "2",
          fr_name: "Port-Saïd",
          en_name: "Port Said",
          ar_name: "بورسعيد",
          tu_name: "Port Said",
          lat: 31.2565,
          long: 32.2841,
        },
        {
          id: "3",
          fr_name: "Alexandrie",
          en_name: "Alexandria",
          ar_name: "الإسكندرية",
          tu_name: "İskenderiye",
          lat: 31.2156,
          long: 29.9553,
        },
        {
          id: "4",
          fr_name: "Charm el-Cheikh",
          en_name: "Sharm El-Sheikh",
          ar_name: "شرم الشيخ",
          tu_name: "Şarm El-Şeyh",
          lat: 27.9158,
          long: 34.3297,
        },
      ],
    },
    {
      name: {
        word: "Jordanie",
        fr: "Jordanie",
        en: "Jordan",
        ar: "الأردن",
        tu: "Ürdün",
        lat: 30.5852,
        long: 36.2384,
        flag: "inso-pics/jordan.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "Amman",
          en_name: "Amman",
          ar_name: "عمان",
          tu_name: "Amman",
          lat: 31.9454,
          long: 35.9284,
        },
      ],
    },
    {
      name: {
        word: "Géorgie",
        fr: "Géorgie",
        en: "Georgia",
        ar: "جورجيا",
        tu: "Gürcistan",
        lat: 42.3154,
        long: 43.3569,
        flag: "inso-pics/georgia.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "Tbilissi",
          en_name: "Tbilisi",
          ar_name: "تبليسي",
          tu_name: "Tiflis",
          lat: 41.7151,
          long: 44.8271,
        },
        {
          id: "2",
          fr_name: "Batoumi",
          en_name: "Batumi",
          ar_name: "باتومي",
          tu_name: "Batımi",
          lat: 41.642,
          long: 41.6338,
        },
      ],
    },
    {
      name: {
        word: "Inde",
        fr: "Inde",
        en: "India",
        ar: "الهند",
        tu: "Hindistan",
        lat: 20.5937,
        long: 78.9629,
        flag: "inso-pics/india.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "Ahmedabad",
          en_name: "Ahmedabad",
          ar_name: "أحمد آباد",
          tu_name: "Ahmedabad",
          lat: 23.0225,
          long: 72.5714,
        },
        {
          id: "2",
          fr_name: "Bombay",
          en_name: "Mumbai",
          ar_name: "مومباي",
          tu_name: "Mumbai",
          lat: 19.076,
          long: 72.8777,
        },
        {
          id: "3",
          fr_name: "New Delhi",
          en_name: "New Delhi",
          ar_name: "نيودلهي",
          tu_name: "Yeni Delhi",
          lat: 28.6139,
          long: 77.209,
        },
      ],
    },
    {
      name: {
        word: "Russie",
        fr: "Russie",
        en: "Russia",
        ar: "روسيا",
        tu: "Rusya",
        lat: 55.7558,
        long: 37.6176,
        flag: "inso-pics/russia.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "Moscou",
          en_name: "Moscow",
          ar_name: "موسكو",
          tu_name: "Moskova",
          lat: 55.7558,
          long: 37.6176,
        },
        {
          id: "2",
          fr_name: "Saint-Pétersbourg",
          en_name: "Saint Petersburg",
          ar_name: "سانت بطرسبرغ",
          tu_name: "Sankt-Peterburg",
          lat: 59.9343,
          long: 30.3351,
        },
      ],
    },
    {
      name: {
        word: "Lebanon",
        fr: "Liban",
        en: "Lebanon",
        ar: "لبنان",
        tu: "Lübnan",
        lat: 33.8938,
        long: 35.5018,
        flag: "inso-pics/lebanon.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "Beyrouth",
          en_name: "Beirut",
          ar_name: "بيروت",
          tu_name: "Beyrut",
          lat: 33.8938,
          long: 35.5018,
        },
      ],
    },
    {
      name: {
        word: "Brésil",
        fr: "Brésil",
        en: "Brazil",
        ar: "البرازيل",
        tu: "Brezilya",
        lat: -15.7801,
        long: -47.9292,
        flag: "inso-pics/brazil.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "Brasília",
          en_name: "Brasília",
          ar_name: "برازيليا",
          tu_name: "Brasília",
          lat: -15.7801,
          long: -47.9292,
        },
        {
          id: "2",
          fr_name: "Rio de Janeiro",
          en_name: "Rio de Janeiro",
          ar_name: "ريو دي جانيرو",
          tu_name: "Rio de Janeiro",
          lat: -22.9068,
          long: -43.1729,
        },
      ],
    },
    {
      name: {
        word: "Malaisie",
        fr: "Malaisie",
        en: "Malaysia",
        ar: "ماليزيا",
        tu: "Malezya",
        lat: 3.139,
        long: 101.6869,
        flag: "inso-pics/malaysia.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "Kuala Lumpur",
          en_name: "Kuala Lumpur",
          ar_name: "كوالالمبور",
          tu_name: "Kuala Lumpur",
          lat: 3.139,
          long: 101.6869,
        },
        {
          id: "2",
          fr_name: "Langkawi",
          en_name: "Langkawi",
          ar_name: "لانكاوي",
          tu_name: "Langkawi",
          lat: 6.35,
          long: 99.8,
        },
      ],
    },
    {
      name: {
        word: "États-Unis",
        fr: "États-Unis",
        en: "United States",
        ar: "الولايات المتحدة",
        tu: "Amerika Birleşik Devletleri",
        lat: 37.0902,
        long: -95.7129,
        flag: "inso-pics/united-states.png",
      },
      wilaya: [
        {
          id: "1",
          fr_name: "New York",
          en_name: "New York",
          ar_name: "نيويورك",
          tu_name: "New York",
          lat: 40.7128,
          long: -74.006,
        },
        {
          id: "2",
          fr_name: "Atlanta",
          en_name: "Atlanta",
          ar_name: "أتلانتا",
          tu_name: "Atlanta",
          lat: 33.749,
          long: -84.388,
        },
        {
          id: "3",
          fr_name: "Miami",
          en_name: "Miami",
          ar_name: "ميامي",
          tu_name: "Miami",
          lat: 25.7617,
          long: -80.1918,
        },
      ],
    },
  ],
};
export const getters = {
  getCountryById: (state) => (value) => {
    return state.country.find((c) => c.name.fr === value);
  },
  getWilayaById: (state) => (countryName, wilayaName) => {
    const country = state.country.find((c) => c.name.fr === countryName);
    const result = country.wilaya.find((c) => c.fr_name == wilayaName);
    return result;
  },
  getCountries(state) {
    return state.country.map((c) => {
      return c.name;
    });
  },
};
